import { Icon } from "@/lib/icons";
import { SettingsActionButton } from "./SettingsActions";
import { SettingsPanel } from "./SettingsPanel";

type AdminAccessStatusProps = {
  roleLabel: string;
  title: string;
  description: string;
  badge: string;
  actionLabel: string;
  onOpen: () => void;
};

export function AdminAccessStatus({ roleLabel, title, description, badge, actionLabel, onOpen }: AdminAccessStatusProps) {
  return (
    <SettingsPanel title={title} description={description} icon="shield">
      <div className="flex flex-col gap-5 pt-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-success/25 bg-success/[0.07] text-success">
            <Icon name="checkCircle" className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground">{roleLabel}</p>
            <p className="mt-1 text-sm leading-6 text-muted-foreground/70">{badge}</p>
          </div>
        </div>
        <SettingsActionButton tone="muted" icon="layoutDashboard" onClick={onOpen}>
          {actionLabel}
        </SettingsActionButton>
      </div>
    </SettingsPanel>
  );
}
